module.exports = __webpack_public_path__ + "static/media/video-camera-disabled.98ee3ec8.svg";